<template>
  <div class="room" v-if="init">
    <input-label class="room__label" :text="$t('rooms.rooms.label')"/>
    <div class="room__list">
      <room v-for="(room, index) in rooms"
            :nb.sync="room.nb"
            :room="room"
            :room-name="room.name"
            :key="index"
            @update:nb="(nb)=>{updateRoom(room, nb)}"
      />
    </div>
    <div class="room__new">
      <el-input
        v-model="newRoom"
        :placeholder="$t('rooms.newRoom.placeholder')">
      </el-input>
      <el-button class="room__new__button"
                 @click="addRoom"
                 :disabled="newRoom.length === 0">
        {{ $t('rooms.newRoom.add') }}
      </el-button>
    </div>
    <modal :visible.sync="displaySuppressCard" height="fit-content" width="300px">
      <div>
        <font-awesome-icon class="warning-deletion__icon" :icon="['fal', 'exclamation-triangle']"/>
        <div class="warning-deletion__content">
          {{ $t('inventory.deletionOnNextPage') }}
        </div>
      </div>
    </modal>
  </div>
  <Loader v-else :text="$t('base.loading')"/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputLabel from '@/components/utils/InputLabel.vue';
import Room from '@/components/furnitures/rooms/Room.vue';
import Loader from '@/components/utils/Loader.vue';
// eslint-disable-next-line import/named
import { CUSTOM_ROOM } from '@/store/modules/furnituresStore';
import Modal from '@/components/utils/Modal.vue';

export default {
  name: 'rooms',
  components: {
    Modal,
    InputLabel,
    Loader,
    Room,
  },
  data() {
    return {
      newRoom: '',
      rooms: [],
      init: false,
    };
  },
  computed: {
    ...mapGetters({
      userRooms: 'furnituresStore/rooms',
    }),
    displaySuppressCard: {
      get() {
        return this.$store.getters['furnituresStore/displayCannotSuppressCard'];
      },
      set(value) {
        this.$store.commit('furnituresStore/SET_CANNOT_DISPLAY_CANNOT_SUPPRESS_CARD',
          value);
      },
    },
    preDefinedRooms() {
      function compare(room1, room2) {
        if (room1.name > room2.name) return 1;
        if (room2.name > room1.name) return -1;
        return 0;
      }

      return [...this.$store.getters['furnituresStore/preDefinedRooms']].sort(compare);
    },
  },
  methods: {
    ...mapActions({
      getPreDefinedRooms: 'furnituresStore/getPreDefinedRooms',
      getRooms: 'furnituresStore/getRooms',
      postRooms: 'furnituresStore/postRooms',
    }),
    addRoom() {
      const room = {
        name: this.newRoom,
        piece_type: CUSTOM_ROOM,
        nb: 1,
      };
      this.rooms.push(room);
      this.updateRoom(room);
      this.newRoom = '';
    },
    updateRoom(room, nb) {
      if (room.nb - 1 === nb) room.nb = nb;
      this.$store.commit('furnituresStore/SET_ROOM', room);
    },
    addCustomRoomToRooms() {
      const customRoomNumberByName = {};
      const customRooms = this.userRooms.filter(r => r.piece_type === CUSTOM_ROOM);
      for (let i = 0; i < customRooms.length; i += 1) {
        if (customRoomNumberByName[customRooms[i].name]) {
          customRoomNumberByName[customRooms[i].name] += 1;
        } else customRoomNumberByName[customRooms[i].name] = 1;
      }
      const customName = Object.keys(customRoomNumberByName);
      customName.sort();
      for (let i = 0; i < customName.length; i += 1) {
        this.rooms.push({
          name: customName[i],
          value: CUSTOM_ROOM,
          nb: customRoomNumberByName[customName[i]],
        });
      }
    },
    addStandardRoomsToRooms() {
      const roomTypes = {};
      const standardUserRooms = this.userRooms.filter(r => r.piece_type !== CUSTOM_ROOM);

      for (let i = 0; i < standardUserRooms.length; i += 1) {
        if (roomTypes[standardUserRooms[i].piece_type]
          && standardUserRooms[i].piece_type) {
          roomTypes[standardUserRooms[i].piece_type] += 1;
        } else if (standardUserRooms[i].piece_type) {
          roomTypes[standardUserRooms[i].piece_type] = 1;
        }
      }

      this.rooms.push(...this.preDefinedRooms
        .map(room => ({
          ...room,
          nb: roomTypes[room.value] ? roomTypes[room.value] : 0,
        })));

      this.rooms.sort((r1, r2) => r1.name > r2.name);
    },
    initRooms() {
      this.addStandardRoomsToRooms();
      this.addCustomRoomToRooms();
    },
  },
  created() {
    if (this.preDefinedRooms.length === 0) {
      this.getPreDefinedRooms()
        .then(() => {
          this.initRooms();
          this.init = true;
        });
    } else {
      this.initRooms();
      this.init = true;
    }
  },
};
</script>

<style scoped lang="scss">
  .room {
    &__list {
      display: flex;
      flex-direction: column;
      padding: 0;
      @include breakpoint(desktop) {
        width: 100%;
        padding: .8em;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 2px 30px;
      }
    }

    &__new {
      width: 100%;
      max-width: 400px;
      display: grid;
      grid-template-columns: minmax(100px, 1fr) 100px;

      @include breakpoint(desktop){
        padding: .8em;
      }

      &__button {
        background: $--color-secondary;
        color: white;
        margin: 0 5px;
      }
    }

    .warning-deletion {
      &__icon {
        width: 42px;
        height: 42px;
        margin: 0 auto 20px auto;
        display: block;
      }
      &__content {
        text-align: center;
      }
    }
  }


</style>
